import Thumbnail from 'component/block/thumbnail'
import { MediaThumbnailTypeEnum } from 'component/block/thumbnail/thumbnail'
import Link from 'next/link'
import React from 'react'
import type { IAssetV2 } from 'type/asset'
import cn from 'util/cn'
import { formatMediaThumbnailType } from 'util/comment'
import { normalizeAsset } from 'util/normalizeAsset'
import type { Nullable } from 'vitest'

interface ISearchResultThumbnail {
  asset: Nullable<IAssetV2>
  isGtm: boolean
  keyword: string
  desc: string
  errorVideoPoster?: string
  onClick: () => void
}

function SearchResultThumbnail({
  asset,
  isGtm,
  keyword,
  desc,

  errorVideoPoster,
  onClick
}: ISearchResultThumbnail) {
  const thumbnailType = formatMediaThumbnailType(asset)
  const { src: videoUrl } = normalizeAsset(asset, true)
  const { src: thumbnailUrl } = normalizeAsset(asset)

  const url =
    isGtm && thumbnailType === MediaThumbnailTypeEnum.Video
      ? videoUrl
      : thumbnailUrl

  return (
    <Link
      className={cn('relative pt-[100%]', isGtm && 'row-span-2')}
      href={`/media/search/${keyword}`}
      onClick={onClick}
    >
      <Thumbnail
        autoPlayVideo={isGtm}
        url={url}
        desc={desc}
        thumbnailType={thumbnailType}
        errorVideoPoster={errorVideoPoster}
      />
    </Link>
  )
}

export default SearchResultThumbnail
